import { render, staticRenderFns } from "./ChangesTable.vue?vue&type=template&id=646d29b3"
import script from "./ChangesTable.vue?vue&type=script&lang=ts"
export * from "./ChangesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports